var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "c-header__search js-header-search": true,
        "is-form-visible": _vm.isFormVisible,
        "is-open": _vm.isOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "c-search" },
        [
          _c("LuigisAutocompleteForm", {
            ref: "autocompleteForm",
            attrs: {
              autocompleteUrl: _vm.autocompleteUrl,
              isFormVisible: _vm.isFormVisible,
              isOpen: _vm.isOpen,
              inputPlaceholder: _vm.inputPlaceholder,
            },
            on: {
              "show-form": _vm.showForm,
              "hide-form": _vm.hideForm,
              searched: _vm.setMatches,
            },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "c-btn c-btn--header", on: { click: _vm.showForm } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Autocomplete.Header.label")))]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", { staticClass: "ico ico-shadow-search" }, [
      _c("i", { staticClass: "path1" }),
      _c("i", { staticClass: "path2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }